import { render, staticRenderFns } from "./ReferenceIndexForm.vue?vue&type=template&id=8240fdd0"
import script from "./ReferenceIndexForm.vue?vue&type=script&lang=js"
export * from "./ReferenceIndexForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports